export enum UserBusinessType {
  INDIVIDUAL = 'individual',
  BUSINESS = 'business'
}
